import React, { useState } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { games, usStates, countries } from "./Games.js"
import Grid from "@material-ui/core/Grid"
import MenuItem from "@material-ui/core/MenuItem"
import TextField from "@material-ui/core/TextField"
import Switch from "@material-ui/core/Switch"
import Tooltip from "@material-ui/core/Tooltip"
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox/Checkbox"

const GameOptions = ({ game, count, max, extraCount, extraMax, unique, allowRepetitions, updateGameOptions }) => {
  const [country, setCountry] = useState(games[game].country)
  const [state, setState] = useState(games[game].state)
  const [customGame, setCustomGame] = useState(false)

  const changeGame = game => updateGameOptions({
    game,
    count: games[game].count || count,
    max: games[game].max || max,
    extraCount: games[game].extraCount || extraCount,
    extraMax: games[game].extraMax || extraMax,
    unique: games[game].unique || unique,
  })

  const changeCountry = country => {
    setCountry(country)
    changeGame(gamesIn(country, state)[0][0])
  }

  const changeState = state => {
    setState(state)
    changeGame(gamesIn(country, state)[0][0])
  }

  const gamesIn = (country, state) => Object
    .entries(games)
    .filter(game => game[1].country === country)
    .filter(game => country !== "USA" || game[0].match(`${state}`))

  return (
    <Grid container spacing={3}>
      <Grid item container alignItems="center" xs={12}>
        <Grid item><Tooltip title="Select a game from the list"><span>Basic</span></Tooltip></Grid>
        <Grid item><Switch color="primary" checked={customGame} onChange={() => setCustomGame(!customGame)} /></Grid>
        <Grid item><Tooltip title="Custom lottery game"><span>Advanced</span></Tooltip></Grid>
      </Grid>
      {
        customGame || <>
          <Grid item xs={12} sm={6} md={4}>
            <TextField select label="Country" onChange={e => changeCountry(e.target.value)} value={country ?? ""}>
              {countries.map(gameCountry => <MenuItem value={gameCountry} key={gameCountry}>{gameCountry}</MenuItem>)}
            </TextField>
          </Grid>
          {country === "USA" && (<Grid item xs={12} sm={6} md={4}>
              <TextField select label="State" onChange={e => changeState(e.target.value)} value={state ?? ""}>
                {usStates.map(usState => <MenuItem value={usState} key={usState}>{usState}</MenuItem>)}
              </TextField>
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4}>
            <TextField select label="Game" onChange={e => changeGame(e.target.value)} value={game ?? ""}>
              {gamesIn(country, state).map(game => <MenuItem value={game[0]} key={game[0]}>{game[0]}</MenuItem>)}
            </TextField>
          </Grid>
        </>
      }
      {customGame && <>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Balls drawn"
            type="number"
            min={1}
            max={10}
            defaultValue={count}
            onChange={(e) => updateGameOptions({ count: parseInt(e.target.value) })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Number of balls"
            type="number"
            min={1}
            max={100}
            defaultValue={max}
            onChange={(e) => updateGameOptions({ max: parseInt(e.target.value) })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Extra balls"
            type="number"
            min={0}
            max={10}
            defaultValue={extraCount}
            onChange={(e) => updateGameOptions({ extraCount: parseInt(e.target.value) })}
          />
        </Grid>
        {extraCount > 0 && <Grid item xs={12} sm={4}>
          <TextField
            label="Number of extra balls"
            type="number"
            min={1}
            max={100}
            defaultValue={extraMax}
            onChange={(e) => updateGameOptions({ extraMax: parseInt(e.target.value) })}
          />
        </Grid>
        }
        {allowRepetitions && <Grid item xs={12} sm={4}>
          <FormControlLabel
            label="Repetitions allowed"
            control={<Checkbox
              color="primary"
              type="checkbox"
              defaultChecked={!unique}
              onChange={(e) => updateGameOptions({ unique: !e.target.checked })}
            />}
          />
        </Grid>
        }
      </>
      }
    </Grid>
  )
}

const mapStateToProps = ({ gameOptions }) => gameOptions

const mapDispatchToProps = dispatch => ({
  updateGameOptions: gameOptions => {
    dispatch({ type: `UPDATE_GAME_OPTIONS`, gameOptions })
  },
})
GameOptions.propTypes = {
  count: PropTypes.number,
  max: PropTypes.number,
  extraCount: PropTypes.number,
  extraMax: PropTypes.number,
  unique: PropTypes.bool,
  allowRepetitions: PropTypes.bool,
}
GameOptions.defaultProps = {
  allowRepetitions: true,
}
export default connect(mapStateToProps, mapDispatchToProps)(GameOptions)
